import { FixaResource } from '../models/login.model';

/** Ex.: 052/123455664 — exibição no header e na listagem de contratos fixa. */
export function formatFixaContractDisplay(contract: FixaResource): string {
  const id = String(contract.customerAccountId ?? '');
  const op =
    contract.operatorCode != null && String(contract.operatorCode).trim() !== ''
      ? String(contract.operatorCode).trim()
      : '';
  return op ? `${op}/${id}` : id;
}

export function formatFixaContractDisplayFromList(
  contracts: FixaResource[],
  customerAccountId: string
): string {
  const id = String(customerAccountId ?? '');
  const contract = contracts.find(c => String(c.customerAccountId ?? '') === id);
  if (!contract) {
    return id;
  }
  return formatFixaContractDisplay(contract);
}
